import { render, staticRenderFns } from "./workgroup-list.vue?vue&type=template&id=1f9abb0e&"
import script from "./workgroup-list.vue?vue&type=script&lang=ts&"
export * from "./workgroup-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports